import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  mode: "hash",
  routes: [
    {
      path: "/",
      component: () => import("@/pages/user/box"),
      meta: {
        nokeep: true,
        nav: true,
        nav1: false,
        navs: true,
        navs1: false
      },
      children: [
        {
          path: "/user_search",
          name: "user_search",
          component: () => import("@/pages/user/search"),
          meta: {
            nokeep: true,
            nav: false,
            nav1: true,
            navs: false,
            navs1: true,
            title: "搜索人才"
          }
        },
        {
          path: "/user_rencai",
          name: "user_rencai",
          component: () => import("@/pages/user/rencai"),
          meta: {
            nokeep: true,
            nav: false,
            nav1: true,
            navs: false,
            navs1: true,
            title: "人才管理"
          }
        },
        {
          path: "/user_position",
          name: "user_position",
          component: () => import("@/pages/user/position"),
          meta: {
            nokeep: true,
            nav: false,
            nav1: true,
            navs: false,
            navs1: true,
            title: "职位中心"
          }
        },
        {
          path: "/user_notice",
          name: "user_notice",
          component: () => import("@/pages/user/notice"),
          meta: {
            nokeep: true,
            nav: false,
            nav1: false,
            navs: false,
            navs1: false,
            title: "通知"
          }
        },
        {
          path: "/user_fabu",
          name: "user_fabu",
          component: () => import("@/pages/user/fabu"),
          meta: {
            nokeep: true,
            nav: false,
            nav1: false,
            navs: false,
            navs1: false,
            title:'军工人才网'
          }
        },
        {
          path: "/user_mianshi",
          name: "user_mianshi",
          component: () => import("@/pages/user/mianshi"),
          meta: {
            nokeep: true,
            nav: false,
            nav1: true,
            navs: false,
            navs1: true,
            title: "面试邀请"
          }
        },
        {
          path: "/user_hr",
          name: "user_hr",
          component: () => import("@/pages/user/hr"),
          meta: {
            nokeep: true,
            nav: false,
            nav1: true,
            navs: false,
            navs1: true,
            title: "HR管理"
          }
        },
        {
          path: "/user_home",
          name: "user_home",
          component: () => import("@/pages/user/home"),
          meta: {
            nokeep: true,
            nav: false,
            nav1: true,
            navs: false,
            navs1: true,
            title: "企业主页"
          }
        },
                {
          path: "/",
          name: "user_index",
          component: () => import("@/pages/user/index"),
          meta: {
            nokeep: true,
            nav: false,
            nav1: true,
            navs: false,
            navs1: true,
            title: "首页"
          }
        },
        {
          path: "/user_indexs",
          name: "user_index",
          component: () => import("@/pages/user/indexs"),
          meta: {
            nokeep: true,
            nav: false,
            nav1: true,
            navs: false,
            navs1: true,
            title: "人才招聘首页"
          }
        },
        {
          path: "/user_collect",
          name: "user_collect",
          component: () => import("@/pages/user/collect"),
          meta: {
            nokeep: true,
            nav: false,
            nav1: true,
            navs: false,
            navs1: true,
            title: "我的收藏"
          }
        },
        {
          path: "/user_xieyi",
          name: "user_xieyi",
          component: () => import("@/pages/user/xieyi"),
          meta: {
            nokeep: true,
            nav: false,
            nav1: false,
            navs: false,
            navs1: false,
            title: "协议"
          }
        },
        {
          path: "/user_user_chatchat",
          name: "user_user_chatchat",
          component: () => import("@/pages/user/chat"),
          meta: {
            nokeep: true,
            nav: false,
            nav1: true,
            navs: false,
            navs1: true,
            title: "互动"
          }
        },
        {
          path: "/user_login",
          name: "user_login",
          component: () => import("@/pages/user/login"),
          meta: {
            nokeep: true,
            nav: false,
            nav1: false,
            navs: false,
            navs1: false,
            title: "登录"
          }
        },
        {
          path: "/titleReview",
          name: "titleReview",
          component: () => import("@/pages/titleReview/index"),
          meta: {
            nokeep: true,
            nav: false,
            nav1: true,
            navs: false,
            navs1: true,
            title: "职称评审"
          }
        }
      ]
    }
  ]
});
// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};



// WEBPACK FOOTER //
// ./src/router/index.js